import React from 'react'
import {Spinner as BSSpinner} from 'react-bootstrap'

const Spinner = _ => <BSSpinner animation='border' size='sm' />

export default Spinner
